import React, {memo} from 'react'
import {ActivityNoteType, NoteData} from "../../../../types/types";
import NoteChangeDataTemplate from "./note-change-data-template/note-change-data-template";
import NoteDefaultTemplate from "./note-default-template/note-default-template";

const autoSize = {minRows: 7, maxRows: 12}


interface NoteStaticProps {
    className?: string;
    type?: ActivityNoteType;
    data?: NoteData
}


const NoteStatic: React.FC<NoteStaticProps> = memo((props: NoteStaticProps) => {
    const {className, type, data} = props;

    switch (type) {
        case 'region-change':
            return <NoteChangeDataTemplate
                oldData={data?.organization?.old}
                newData={data?.organization?.new}
                className={className}
            >
                <div style={{margin: '10px 0 5px'}}>
                    Причина изменения: {data?.text}
                </div>
                </NoteChangeDataTemplate>
        case 'manager-change':
            return <NoteChangeDataTemplate
                oldData={data?.from}
                newData={data?.to}
                className={className}
            />
        default:
            return <NoteDefaultTemplate
                text={data?.text}
                className={className}
            />
    }
})

export default NoteStatic
